export class ReCaptchaKey {
    public static siteKey = '6Lcoz7kUAAAAALW3JWyDWr-pQv3IqOj-znzt-Fv9';
}
